import React, { useEffect, useState } from 'react'
import FormField from './FormField';

const InventoryCreateForm = ({ initialData, onSave, onClose, countries, states }) => {

  const [formData, setFormData] = useState({
    inventory_name: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    pincode: '',
    state_id: '',
    country_id: '',
    land_mark: '',
    ...initialData,
    ...(initialData?.address ? initialData.address : {}),
  });
  
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        ...(initialData.address || {}),
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.inventory_name) {
      newErrors.inventory_name = 'Inventory name is required.';
    }
    if (!formData.address_line_1) {
      newErrors.address_line_1 = 'Address Line 1 is required.';
    }
    if (!formData.city) {
      newErrors.city = 'City is required.';
    }
    if (!formData.pincode) {
      newErrors.pincode = 'Pincode is required.';
    }
    if (!formData.state_id) {
      newErrors.state_id = 'State is required.';
    }
    if (!formData.country_id) {
      newErrors.country_id = 'Country is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setErrors({});
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField
          label="Inventory Name"
          id="inventory_name"
          type="text"
          value={formData.inventory_name}
          onChange={handleChange}
          required={true}
          errorMessage={errors.inventory_name}
        />
        <div className="sm:col-span-2">
          <FormField
            label="Address Line 1"
            id="address_line_1"
            type="text"
            value={formData.address_line_1}
            onChange={handleChange}
            required={true}
            errorMessage={errors.address_line_1}
          />
        </div>
        <div className="sm:col-span-2">
          <FormField
            label="Address Line 2"
            id="address_line_2"
            type="text"
            value={formData.address_line_2}
            onChange={handleChange}
          />
        </div>
        <FormField
          label="City"
          id="city"
          type="text"
          value={formData.city}
          onChange={handleChange}
          required={true}
          errorMessage={errors.city}
        />
        <FormField
          label="Pincode"
          id="pincode"
          type="text"
          value={formData.pincode}
          onChange={handleChange}
          required={true}
          errorMessage={errors.pincode}
        />
        <FormField
          label="State"
          id="state_id"
          type="select"
          value={formData.state_id}
          onChange={handleChange}
          required={true}
          errorMessage={errors.state_id}
        >
          <option value="">Select a state</option>
          {states.map(state => (
            <option key={state.id} value={state.state_id}>{state.state_name}</option>
          ))}
        </FormField>
        <FormField
          label="Country"
          id="country_id"
          type="select"
          value={formData.country_id}
          onChange={handleChange}
          required={true}
          errorMessage={errors.country_id}
        >
          <option value="">Select a country</option>
          {countries.map(country => (
            <option key={country.country_id} value={country.country_id}>{country.country_name}</option>
          ))}
        </FormField>
      </div>
      <div className="mt-6 flex justify-end space-x-3">
        <button
          type="button"
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md shadow-sm hover:bg-gray-300 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-sm hover:bg-indigo-700 transition-colors"
        >
          Save Inventory
        </button>
      </div>
    </form>
  );
};

export default InventoryCreateForm